



























import { Vue, Component, Prop,PropSync, Watch } from 'vue-property-decorator'
import moment from 'moment'

//首页的课程分类的列表
@Component({
  name: 'notReadNotifyDialog',
  components: {
  },
  props: {
  }
})
export default class notReadNotifyDialog extends Vue {
    @Prop({ default: () => [] }) notReadNotifyLists!: Array<any>; //未读
    
    private dialogShow:boolean = false;//是否弹窗
    private moment = moment;

    @Watch('notReadNotifyLists',{deep:true})
    onNotReadNotifyListsChange(val:any){
        if(val != null && val.length > 0){
            this.dialogShow = true;
        }else{
            this.dialogShow = false;
        }
    }

    created(){
        if(this.notReadNotifyLists != null && this.notReadNotifyLists.length > 0){
            this.dialogShow = true;
        }else{
            this.dialogShow = false;
        }
    }

    /**
     * 前往公告
     * @param notify 
     */
    gotoNotify(notify:any){
        this.$router.push(`/noticeDetail?id=${notify.id}&courseId=${notify.courseid}&courseRole=0`);
    }

}
